import script from "./GrouperTitle.vue?vue&type=script&lang=ts&setup=true"
export * from "./GrouperTitle.vue?vue&type=script&lang=ts&setup=true"

import "./GrouperTitle.vue?vue&type=style&index=0&id=0346d986&lang=scss"

const __exports__ = script;

export default __exports__
import QBar from 'quasar/src/components/bar/QBar.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QToolbarTitle from 'quasar/src/components/toolbar/QToolbarTitle.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QBar,QIcon,QToolbarTitle,QBtn});
